import { Dialog, Button } from '@agro1desenvolvimento/react-components';
import { useRef, useCallback, useState } from 'react';
import Webcam from 'react-webcam';

interface Props {
  visible: boolean;
  onHide: () => void;
  onCapture: (imagemUrl: string) => void;
}

export default function TirarFoto({ visible, onHide, onCapture }: Props) {
  const webcamRef = useRef<Webcam>(null);
  const [facingMode, setFacingMode] = useState<'user' | 'environment'>('environment');

  const capturarFoto = useCallback(() => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
      onCapture(imageSrc);
      onHide();
    }
  }, [onCapture, onHide]);

  const trocarCamera = useCallback(() => {
    setFacingMode((prevMode) => (prevMode === 'user' ? 'environment' : 'user'));
  }, []);

  if (!visible) return null;

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Tirar foto"
      className="tirar-foto-modal"
      breakpoints={{ '960px': '100vw' }}
      style={{ width: '50vw', minWidth: '320px' }}
    >
      <div className="tirar-foto-content">
        <div className="webcam-container">
          <Webcam
            ref={webcamRef}
            height={400}
            width="100%"
            screenshotFormat="image/jpeg"
            style={{ maxWidth: '100%', height: 'auto' }}
            videoConstraints={{
              facingMode,
            }}
            disablePictureInPicture
          />
          <button
            type="button"
            className="trocar-camera-button"
            onClick={trocarCamera}
            title={facingMode === 'user' ? 'Trocar para câmera traseira' : 'Trocar para câmera frontal'}
          >
            <i className="fas fa-sync-alt" />
          </button>
        </div>
        <div className="foto-actions">
          <Button label="Cancelar" onClick={onHide} className="p-button-secondary" />
          <Button label="Capturar" onClick={capturarFoto} />
        </div>
      </div>
    </Dialog>
  );
}
